module.exports = "<div #pdn=\"\" *ngIf=\"visible\" class=\"payment-due-notice\"><p-messages [value]=\"messages\" [escape]=\"false\"></p-messages></div>";